import { createContext, useContext, type ReactNode } from "react";

export interface ConfirmDialogOptions {
  title?: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}

export type ConfirmFunction = (options?: ConfirmDialogOptions) => Promise<boolean>;

// Leaf module (no component imports) so both ConfirmDialogProvider and dialog
// components like AppModal can depend on it without import cycles.
export const ConfirmDialogContext = createContext<ConfirmFunction | null>(null);

export function useConfirmDialog(): ConfirmFunction {
  const confirm = useContext(ConfirmDialogContext);
  if (!confirm) {
    throw new Error(
      "useConfirmDialog must be used within a ConfirmDialogProvider",
    );
  }
  return confirm;
}
